
import React, { useEffect, useState } from "react";
import styles from "./Footer.module.css";
import { SocialService } from "../../services/social_service";
import { SettingService } from "../../services/setting_service";
import { FaMapMarkerAlt, FaPhone, FaEnvelope } from "react-icons/fa";
import config from "../../config/config";
import TopToPage from "../TopToPage/TopToPage";

const Footer = () => {
  const socialService = SocialService();
  const settingService = SettingService();
  const [socialData, setSocialData] = useState([]);
  const [settingData, setSettingData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [imageErrors, setImageErrors] = useState({});

  useEffect(() => {
    const fetchSettingData = async () => {
      try {
        await settingService.fetchAllSetting(setSettingData);
      } catch (error) {
        console.error("Error fetching data", error);
      } finally {
        setLoading(false);
      }
    };
    fetchSettingData();
  }, []);

  useEffect(() => {
    const fetchSocialData = async () => {
      try {
        await socialService.fetchAllSocial(setSocialData);
      } catch (error) {
        console.error("Error fetching Data", error);
      } finally {
        setLoading(false);
      }
    };
    fetchSocialData();
  }, []);

  const handleImageError = (socialId) => {
    setImageErrors((prev) => ({ ...prev, [socialId]: true }));
  };

  const getFullImageUrl = (iconPath) => {
    if (!iconPath) return null;

    // If it's already a full URL, return as is
    if (iconPath.startsWith("http")) {
      return iconPath;
    }

    // Use the baseURL from your config
    return `${config.baseURL}${iconPath}`;
  };

  // Format phone number for display
  const formatPhoneNumber = (phone) => {
    if (!phone) return null;
    // Add spacing for better readability
    return phone.replace(/(\d{3})(\d{3})(\d{4})/, "$1 $2 $3");
  };
  return (
    <footer className={styles.footer}>
      <div className={styles.container}>
        {/* About Section */}
        {/* <div className={styles.about}>
          {settingData && (
            <>
              <h2 className={styles.heading}>Royal Sports League</h2>
              <p className={styles.text}>{settingData.tagline}</p>
            </>
          )}
        </div> */}

        <div className={styles.contact}>
          <h2 className={styles.heading}>Contact Info</h2>
          <div className={styles.contactList}>

            {settingData?.contact_1 && (
              <div className={styles.contactItem}>
                <p
                  className={styles.contactLink}
                >
                  <FaPhone className={styles.contactIcon} />
                  {formatPhoneNumber(settingData.contact_1)}
                </p>
              </div>
            )}

            {settingData?.contact_2 && (
              <div className={styles.contactItem}>

                <p
                  className={styles.contactLink}
                >
                  <FaPhone className={styles.contactIcon} />{formatPhoneNumber(settingData.contact_2)}
                </p>
              </div>
            )}

            {settingData?.email && (
              <div className={styles.contactItem}>
                <FaEnvelope className={styles.contactIcon} style={{ marginTop: "5px" }} />
                <p
                  className={styles.contactLink}
                >
                  {settingData.email}
                </p>
              </div>
            )}
            {settingData?.address && (
              <div className={styles.contactItem} style={{ display: "flex", alignItems: "start" }}>

                <p className={styles.contactText}>
                  <FaMapMarkerAlt className={styles.contactIcon} />{settingData.address}
                </p>
              </div>
            )}
          </div>
        </div>

        {/* Quick Links */}
        <div className={styles.links}>
          <h2 className={styles.heading}>Quick Links</h2>
          <ul className={styles.linkList}>
            <li>
              <a href="/" className={styles.link}>
                Home
              </a>
            </li>
            <li>
              <a href="/about" className={styles.link}>
                About Us
              </a>
            </li>
            <li>
              <a href="/event" className={styles.link}>
                Events
              </a>
            </li>
            <li>
              <a href="/contact" className={styles.link}>
                Contact Us
              </a>
            </li>
          </ul>
        </div>

        {/* Social Links - Using backend icons */}
        <div className={styles.social}>
          <h2 className={styles.heading}>Follow Us</h2>
          <div className={styles.socialIcons}>
            {loading ? (
              <div className={styles.loading}>Loading social links...</div>
            ) : socialData.length > 0 ? (
              socialData.map((social) => (
                <a
                  key={social.id}
                  href={social.social_link}
                  target="_blank"
                  rel="noopener noreferrer"
                  className={styles.socialLink}
                  title={social.name}
                >
                  {social.icon && !imageErrors[social.id] ? (
                    <img
                      src={getFullImageUrl(social.icon)}
                      alt={social.name || "Social Icon"}
                      className={styles.socialIconImage}
                      onError={() => handleImageError(social.id)}
                    />
                  ) : (
                    <div className={styles.socialFallback}>
                      {social.name ? social.name.charAt(0).toUpperCase() : "🌐"}
                    </div>
                  )}
                </a>
              ))
            ) : (
              <div className={styles.noLinks}>No social links available</div>
            )}
          </div>
        </div>
        <TopToPage />
      </div>

      {/* Bottom Bar */}
      <div className={styles.bottomBar}>
        Powered by <a href="https://adyant.co.in/" target="__blank">Adyant SoftTech</a> © {new Date().getFullYear()} Royal Sports League — All Rights Reserved.
      </div>

    </footer>
  );
};

export default Footer;
